/**
 * megaMenuNav
 */

import $ from 'jquery';

// Module dependencies
import 'protons';

// Module styles
import './_mega-menu-nav.scss';

// Module template
import './_mega-menu-nav.twig';

export const name = 'megaMenuNav';

export const defaults = {
  dummyClass: 'js-megaMenuNav-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable($context, { megaMenuNav = {} }) {
  // Find our component within the DOM
  const $megaMenuNav = $('.mega-menu-component', $context);
  // Bail if component does not exist
  if (!$megaMenuNav.length) {
    return;
  }
  // Merge defaults with incoming settings
  // eslint-disable-next-line no-unused-vars
  const settings = Object.assign(defaults, megaMenuNav);
  // An example of what could be done with this component
  $megaMenuNav.addClass(settings.dummyClass);

  // const $openMegaNavButton = $megaMenuNav.find('.mega-toggle');
  const $navMegaWrapper = $megaMenuNav.find('.mega-nav-container');


  const $childNavToggle = $megaMenuNav.find(
    '.dropdown-toggle .global-nav__nav-toggle'
  );
  const $megaDropToggle = $megaMenuNav.find('.has-mega .dropdown-fullwidth');

  // Toggle nav child links open/close
  $childNavToggle.on('click', $childNavToggle, el => {
    const $plus = $(el.currentTarget);
    $plus
      .toggleClass('open-dropdown')
      .siblings('.dropdown-fullwidth')
      .slideToggle('fast');
    $plus.parent('li').toggleClass('section-open');
    el.preventDefault();
    $megaDropToggle.toggleClass('show');
    $megaDropToggle.parent('li').toggleClass('show');

  });
}
// Originally this was based on window size, now just needs to change to no-dropdown no matter what
$(window).on('resize load pagebeforecreate', () => {
  if ($(window).width() > 1119.99) {
    $('.global-nav__primary-nav-item.has-mega .dropdown-toggle').attr(
      'data-toggle',
      'no-dropdown'
    );
  } else {
    $('.global-nav__primary-nav-item.has-mega .dropdown-toggle').attr(
      'data-toggle',
      'no-dropdown'
    );
  }
});
// -- Handling  key board tabbing - start -- //
document.querySelectorAll('[role="menubar"]').forEach(menu => {
  const menuItems = menu.querySelectorAll('li');

  menuItems.forEach(item => {
    ['focusin', 'mouseenter'].forEach(eventType => {
      item.addEventListener(eventType, e => {
        // Remove focus from all siblings, so that multiple menu is not open in the same time
        Array.from(item.parentElement.children).forEach(sibling => {
          if (sibling !== item) {
            sibling.classList.remove('focus');
            const link = sibling.querySelector('[role="menuitem"]');
            if (link) link.setAttribute('aria-expanded', 'false');
          }
        });
        // focus the item and display submenu
        item.classList.add('focus');
        const submenuTrigger = item.querySelector('[role="menuitem"]');
        const submenu = item.querySelector('div[role="menu"]');
        if (submenuTrigger && submenu) {
          submenuTrigger.setAttribute('aria-expanded', 'true');
        }
      });
    });

    ['focusout', 'mouseleave'].forEach(eventType => {
      item.addEventListener(eventType, e => {
        // settimeout used here to delay execution until the browser knows where focus is
        setTimeout(() => {
          if (!item.contains(document.activeElement)) {
            item.classList.remove('focus');
            const link = item.querySelector('[role="menuitem"]');
            if (link) link.setAttribute('aria-expanded', 'false');
          }
        }, 0);
      });
    });
  });
});

// Add arrow navigation and escape close for mega menu items
document.querySelectorAll('.dropdown-menu[role="menu"]').forEach(menu => {
  // filter out all a tags which are not visible and hidden
  const getVisibleLinks = () =>
    Array.from(menu.querySelectorAll('a[href]')).filter(link => {
      const style = window.getComputedStyle(link);
      return style.display !== 'none' && style.visibility !== 'hidden' && link.offsetParent !== null;
    });

  menu.addEventListener('keydown', e => {
    const links = getVisibleLinks();
    const currentIndex = links.indexOf(document.activeElement);

    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        if (links.length) {
          const nextIndex = (currentIndex + 1) % links.length;
          links[nextIndex].focus();
        }
        break;

      case 'ArrowUp':
        e.preventDefault();
        if (links.length) {
          const prevIndex = (currentIndex - 1 + links.length) % links.length;
          links[prevIndex].focus();
        }
        break;

      case 'Escape':
        e.preventDefault();
        const parentLi = menu.closest('li.has-mega');

        if (parentLi) {
          // remove focus class from parent
          parentLi.classList.remove('focus');
          // hide the submenu
          menu.style.display = 'none'
          menu.setAttribute('aria-hidden', 'true');

          // focus the main anchor in the li
          const link = parentLi.querySelector('a');
          if (link) {
            link.focus();
          } else {
            parentLi.setAttribute('tabindex', '-1');
            parentLi.focus();
          }
        }
        break;
    }
  });
});

// -- Handling  key board tabbing - END -- //
export default enable;
